import React from 'react';
import './About.css';
import { Sparkles, Cpu, Award } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        
        {/* Left Column: Text */}
        <div className="about-text-column">
          <div className="about-tag">
            <Sparkles size={16} className="text-purple-accent" />
            <span>About Me</span>
          </div>
          
          <h2 className="about-title">
            Shaping digital worlds through <span className="text-purple-gradient">three-dimensional</span> art
          </h2>
          
          <p className="about-description">
            I am a 3D Artist specializing in creating immersive environments, high-quality models, and interactive visual experiences. I combine artistic sensibility with technical expertise to bring complex concepts to life.
          </p>
          
          <p className="about-description">
            My work ranges from hard-surface modeling to creating procedural materials, with a constant focus on optimization for real-time engines and 3D web integrations.
          </p>

          <div className="about-highlights">
            <div className="highlight-item">
              <div className="highlight-icon-wrapper">
                <Cpu size={20} />
              </div>
              <div className="highlight-info">
                <h4>3D Optimization</h4>
                <p>Assets optimized for real-time web performance.</p>
              </div>
            </div>
            
            <div className="highlight-item">
              <div className="highlight-icon-wrapper">
                <Award size={20} />
              </div>
              <div className="highlight-info">
                <h4>Artistic Quality</h4>
                <p>Obsessive attention to detail, lighting, and color.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: Portrait */}
        <div className="about-image-column">
          <div className="image-portrait-container">
            <div className="glow-effect"></div>
            
            {/* Geometric wireframe representation rotating behind/around the card */}
            <div className="wireframe-sphere">
              <div className="wireframe-ring ring-1"></div>
              <div className="wireframe-ring ring-2"></div>
              <div className="wireframe-ring ring-3"></div>
            </div>
            
            <div className="portrait-card">
              <div className="portrait-image-wrapper">
                <img 
                  src="/assets/antonino-cuti.png" 
                  alt="Antonino Cuti - 3D Artist" 
                  className="portrait-img" 
                />
              </div>
              
              <div className="portrait-badge">
                <span className="badge-dot"></span>
                <span className="badge-text">3D Artist</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default About;

